import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'

import { useCallback } from 'react'

export type EventsConfig = {
  eventName: string
  interaction: string
}

export type ExtraParams = Record<string, string | number>

export const useSettingUpAnalyticsEvent = () => {
  const { logAnalyticsEvent } = useFirebaseContext()
  const settingUpAnalyticsEvent = useCallback(
    (config: EventsConfig, extraParams?: ExtraParams) => {
      logAnalyticsEvent(config?.eventName, {
        interaction: `${config?.interaction}`,
        ...(extraParams ?? {}),
      })
    },
    [logAnalyticsEvent],
  )

  return settingUpAnalyticsEvent
}
